import { apolloClient } from "@/plugins/vue-apollo.js";

const updateDefaultPromotionCharges = async (_variables) => {
    // , limit, skip
  let responseFromApi;
  let variables = _variables;
  // debugger
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/fee/update_default_promotion_charges.graphql"),
      variables: variables,
      
      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/fee/default_promotion_charge_query.graphql"),
        };
        let deafaultPrice = store.readQuery(query);
        // debugger
          deafaultPrice.getDefaultPromotionCharge = data.updateDefaultPromotionCharges
        store.writeQuery({
          ...query,
          data: deafaultPrice,
        });
      },
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { updateDefaultPromotionCharges };
